import React from "react";

export default function Messages() {
  return (
    <div className="content-container">
      <div className="home-container">
        <h1 style={{fontSize: "80px"}}>UNDER CONSTRUCTION</h1>
        <svg
          id="flat"
          height="512"
          viewBox="0 0 512 512"
          width="512"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="m432 280v72l56 136h-24l-80-104-16-48 27.584-56z"
            fill="#4b6275"
          />
          <path
            d="m432 212.211v67.789l-40 24-48 72-32 112h-24l8-128 41.11-113.052 86.386-48.962z"
            fill="#62798c"
          />
          <path
            d="m248.466 277.903 15.534-69.903 32-16 35.035 58.392 92.461-52.406-15.496-61.986 24-8 8 72h24l8-80-16-32-56-8-64 8-40 16-48 32-32 64 8.267 90.933z"
            fill="#d1e4ff"
          />
          <path
            d="m360 85v51l-40 16-38.4-38.4-18.6 12.4 33 66 35.035 58.392 92.461-52.406-15.496-61.986-30.4-53.2z"
            fill="#f78e00"
          />
          <path
            d="m488 208-32 16-32-8-30.82007 17.78-155.44993 89.68-21.73 12.54 8 32-6.31006 3.16016a120.52411 120.52411 0 0 1 -113.68994-3.16016l2.52-8.81982a120.49827 120.49827 0 0 1 56.08984-71.53028l13.39016-7.6499 24 24 22.06006-11.87988 154.54-83.21021 31.39994-16.90991 8-24 44.21-29.47z"
            fill="#c78640"
          />
          <path
            d="m488 208-32 16-32-8-30.82 17.78-16.58-24.87 31.4-16.91 8-24 44.21-29.47z"
            fill="#718799"
          />
          <path
            d="m264 208-40-24-8 16 8.267 90.933 24.199-13.03z"
            fill="#ffceb6"
          />
          <path d="m432 128 24-40 16 32-8 80h-24z" fill="#ffceb6" />
          <path
            d="m288 488-16.71991-25.07987a43.70936 43.70936 0 0 0 -42.5498-19.02446h-.00006a43.70933 43.70933 0 0 1 -43.66188-20.78177l-3.0465-5.07749a43.70939 43.70939 0 0 0 -16.25332-15.72057l-44.96036-24.978a43.7094 43.7094 0 0 0 -35.0492-3.2575l-12.58308 4.19435a43.7093 43.7093 0 0 1 -33.36947-2.37151l-15.80642-7.90318v120z"
            fill="#ffcc4d"
          />
          <path
            d="m336 64v24a24 24 0 0 1 -24 24 24 24 0 0 1 -24-24v-24z"
            fill="#ffceb6"
          />
          <path
            d="m336 64h-72l16-16 1.64214-4.92642a27.89464 27.89464 0 0 1 26.46318-19.07358 27.89463 27.89463 0 0 1 27.89468 27.89464z"
            fill="#ffc431"
          />
          <path
            d="m216 336 8 32-6.31006 3.16016a120.52411 120.52411 0 0 1 -113.68994-3.16016l2.52-8.81982a120.49827 120.49827 0 0 1 56.08984-71.53028l13.39016-7.6499 24 24 22.06006-11.87988 15.66994 31.33988z"
            fill="#62798c"
          />
        </svg>
      </div>
    </div>
  );
}
